import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import SglContext from '../SglContext';
import $ from 'jquery';
import { useNavigate } from 'react-router-dom';
import "./addDropClass.css";

import tick_icon from "../images/tick_icon.png";


// //API END POINTS
// const sgl_webservice_iphone_entry = process.env.REACT_APP_SGL_API+'/iphonev2/addentryv2/';
// const sgl_webservice_iphone_class = process.env.REACT_APP_SGL_API+'/iphonev2/classadddropv2/';
// const user_info_url = process.env.REACT_APP_NEST_API+'/users/getLoggedInUser';


class AddDropTrainer extends React.Component {
      
    state = {
        current_show: localStorage.getItem('show_id'),

        governing_organization: '',
        company_name: '',
        logged_in_people_id: '',
        credit_hold:false,
        credit_hold_count: 0,
        can_add_drop_class: true,

        entry_on_credit_hold: false,
        show_data:{},
        trainer_entries_data: [],
        riders_list: [],
        class_selection_error_msg: '',
        entry_numbers:'',
        userData: {},

        pending_requests_list: [],
        switch_allowed: 0,
        switch_company_name: '',
        loading: true,
    }

    constructor() {
        super();
      // bind function in constructor instead of render
    }

    // onShowChange(show_id) {
    //   // show_id=20190;
    //     localStorage.setItem('show_id', show_id);
    //     this.getSelectedShowEntries(show_id);
    //     this.setState({
    //         current_show: show_id,
    //   });
    // }

    get sgl_webservice_iphone_entry() {
        return this.context.sglApiUrl + '/iphonev2/addentryv2/';
    }

    get sgl_webservice_iphone_class() {
        return this.context.sglApiUrl + '/iphonev2/classadddropv2/';
    }

    get user_info_url() {
        return this.context.nestApiUrl + '/users/getLoggedInUser';
    }

    componentDidUpdate(prevProps){
        if(prevProps.current_show !== this.props.current_show){
            var show_id = this.props.current_show;
            this.getSelectedShowEntries(show_id);
            this.setState({
                current_show: show_id,
            });
            
        }
    }
    componentDidMount() {
        var switches = this.context.switches.switches;
        // switch_name: "Class Adds/Drops"
        var switch_found = switches.find(el => el.switch_name === "Class Adds/Drops");
        var switch_allowed = 0;
        if(switch_found){
            switch_allowed = switch_found.value;
        }
        this.setState({
            switch_allowed: switch_allowed
        });
        if(switch_allowed){
            this.getAllData(localStorage.getItem('show_id'));
            window.addEventListener('beforeunload', this.handleLeavePage);
            } else {
            this.setState({
            switch_allowed: switch_allowed,
            switch_company_name: this.context.switches.company_name?this.context.switches.company_name:'The Company',
            loading:false
            })
        }
      
    }
    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleLeavePage);
    }
  
    handleLeavePage(e) {
        const confirmationMessage = 'You have not saved your classes. If you leave this page, your changes will be lost.';
        e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
        return confirmationMessage;              // Gecko, WebKit, Chrome <34
    }
    
    getAllData(show_id){
        this.getUserData();
        document.title = "Trainer add drop";

        this.getSelectedShowEntries(show_id);
    }

    getSelectedShowEntries(show_id){
        axios.get(this.sgl_webservice_iphone_class+'TrainerClassAddDrop',{
            params : {
                show_id : show_id,
                company_id: this.context.company_id,
                team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
            }
        }).then(results => {
            this.handleGetEntriesData(results.data, show_id);
        })
    }

    handleGetEntriesData(response, show_id){
        var entries_data = (response.trainer_entries_data && response.trainer_entries_data.length > 0)?response.trainer_entries_data:[];

        const entries_list = entries_data.map((entry) => {
            return {...entry, 
                'add_classes': '',
                'drop_classes': '',
                'error_msg': '',
                'updated': false,
                'success_add': false,
                'success_drop': false
            };
        });

      this.setState({
        show_data: response.show_data,
        credit_hold: response.credit_hold_enabled?response.credit_hold_enabled:false,
        credit_hold_count: response.credit_hold_count?response.credit_hold_count:0,
        can_add_drop_class: response.can_add_drop_class !== undefined ? response.can_add_drop_class : true,
        trainer_entries_data: entries_list,
        pending_requests_list: response.pending_requests?response.pending_requests:[],
        loading: false
      });

    }

    //////////////////// check add classes ///////////// 
    checkClassAdds(evt, entry_data){
        var class_numbers = evt.target.value;
        if (class_numbers.trim() !== ''){
            this.checkSelectClassToAdd(this.state.current_show, class_numbers, entry_data.rider_id, entry_data.horse_id, entry_data.entry_id, entry_data);
        } else {
            let success_add = false;
            this.setState(prevState => ({
                trainer_entries_data: prevState.trainer_entries_data.map(el => (el.entry_id === entry_data.entry_id && el.rider_id === entry_data.rider_id ? { ...el, success_add } : el)) 
            }))
        }
    }
    updateAddClassNumbers(evt, entry_data) {
        var add_classes = evt.target.value;
        this.setState(prevState => ({
            trainer_entries_data: prevState.trainer_entries_data.map(el => (el.entry_id === entry_data.entry_id && el.rider_id === entry_data.rider_id ? { ...el, add_classes } : el)) 

        }))
    }

    checkSelectClassToAdd(show_id, class_numbers, rider_id, horse_id, entry_id, entry_data){
        axios.get(this.sgl_webservice_iphone_class+'ClassAdd',{
            params : {
                show_id : show_id,
                class_numbers : class_numbers,
                entry_id: entry_id,
                rider_id : rider_id,
                horse_id : horse_id,
                company_id: this.context.company_id
            }
        }).then(results => {
            this.setClassAddResponseData(results.data, entry_data);
        })
    }

    setClassAddResponseData(response_data, entry_data){
        var error_msg = '';
        var success_count = 0;
        var success_classes = '';
        response_data.forEach(class_response => {          
            if (class_response.success) {
              success_count += 1;
              success_classes += class_response.number + ' ';
            } else {
              error_msg += class_response.error + ' \n';
            }
            
        });
        entry_data.error_msg = error_msg;
        if (success_count > 0) {
            entry_data.add_classes = success_classes;
            entry_data.updated = true;
            entry_data.success_add = true;
        } else {
            entry_data.add_classes = '';
            entry_data.success_add = false;

        }
        this.state.trainer_entries_data.forEach((trainer_entry_data, entry_index) => {
            if(trainer_entry_data.entry_id === entry_data.entry_id && trainer_entry_data.rider_id === entry_data.rider_id) {
              this.state.trainer_entries_data[entry_index] = entry_data;
              this.setState({
                trainer_entries_data: this.state.trainer_entries_data
              });
            }
        });
        this.setState({
          class_selection_error_msg: 'Please click Save button to submit the changes.'
        });
        document.getElementById('step_1_warning').style.display = "block";

    }
      //////////////////// end check add classes ///////////// 
      //////////////////// check drop classes ///////////// 
    checkClassDrops(evt, entry_data){
        var class_numbers = evt.target.value;
        if (class_numbers.trim() !== ''){
            this.checkSelectClassToDrop(this.state.current_show, class_numbers, entry_data.rider_id, entry_data.horse_id, entry_data.entry_id, entry_data);
        } else {
            let success_drop = false;
            this.setState(prevState => ({
                trainer_entries_data: prevState.trainer_entries_data.map(el => (el.entry_id === entry_data.entry_id && el.rider_id === entry_data.rider_id ? { ...el, success_drop } : el)) 
            }))
        }
    }
    updateDropClassNumbers(evt, entry_data) {
        var drop_classes = evt.target.value;
        this.setState(prevState => ({
            trainer_entries_data: prevState.trainer_entries_data.map(el => (el.entry_id === entry_data.entry_id && el.rider_id === entry_data.rider_id ? { ...el, drop_classes } : el)) 

        }))
    }

    checkSelectClassToDrop(show_id, class_numbers, rider_id, horse_id, entry_id, entry_data){
        axios.get(this.sgl_webservice_iphone_class+'ClassDrop',{
            params : {
                show_id : show_id,
                class_numbers : class_numbers,
                entry_id: entry_id,
                rider_id : rider_id,
                horse_id : horse_id,
                company_id: this.context.company_id
            }
        }).then(results => {
            this.setDropClassResponseData(results.data, entry_data);
        })
    }

    setDropClassResponseData(response_data, entry_data){
        var error_msg = '';
        var success_count = 0;
        var success_classes = '';
        response_data.forEach(class_response => {          
            if (class_response.success) {
              success_count += 1;
              success_classes += class_response.number + ' ';
            } else {
              error_msg += class_response.error + ' \n';
            }
            
        });
        // if (error_msg != ''){
        entry_data.error_msg = error_msg;
        // }
        if (success_count > 0) {
            entry_data.drop_classes = success_classes;
            entry_data.updated = true;
            entry_data.success_drop = true;
        } else {
            entry_data.drop_classes = '';
            entry_data.success_drop = false;

        }
        this.state.trainer_entries_data.forEach((trainer_entry_data, entry_index) => {
            if(trainer_entry_data.entry_id === entry_data.entry_id && trainer_entry_data.rider_id === entry_data.rider_id) {
              this.state.trainer_entries_data[entry_index] = entry_data;
              this.setState({
                trainer_entries_data: this.state.trainer_entries_data
              });
            }
        });
        this.setState({
          class_selection_error_msg: 'Please click Save button to submit the changes.'
        });
        document.getElementById('step_1_warning').style.display = "block";
        
  
    }
      //////////////////// end check drop classes ///////////// 
    
    saveTrainerAddDropApiCall(show_id, rider_classes) {
        axios.get(this.sgl_webservice_iphone_class+'SaveTrainerEntriesAddDrop',{
            params : {
                show_id: show_id,
                add_drop_entries_data:rider_classes,
                total_entries: 0,
                customer_id: this.context.company_id,
                sgl_plugin: true,
                team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
            }
        }).then(results => {
            this.setAddDropClassesResponseData(results.data);
        })
    }

    saveClassAddDrop = () => (e) => {
        document.getElementById('step_1_warning').style.display = "none";

        var entry_classes = [];
        this.state.trainer_entries_data.forEach(entry_data => {
            if(entry_data.drop_classes != '' || entry_data.add_classes != ''){
            var entry_class_data = {
                "add_class_numbers": entry_data.add_classes,
                "drop_class_numbers": entry_data.drop_classes,
                "rider_id": entry_data.rider_id,
                "rider_name": entry_data.rider_name,
                "entry_id": entry_data.entry_id,
                "horse_id": entry_data.horse_id
            };
            entry_classes.push(entry_class_data);
            }

        });

        if(entry_classes.length > 0){
            this.saveTrainerAddDropApiCall(this.state.current_show, JSON.stringify(entry_classes));
        } else {
            this.setState({
                class_selection_error_msg: 'There are no changes to save.'
            });
            document.getElementById('step_1_warning').style.display = "block";
        }
    }

    setAddDropClassesResponseData(response_data){
        if(response_data.add_drop_successful) {
            this.setState({
            pending_requests_list: response_data.pending_requests?response_data.pending_requests:[],
            });
            document.getElementById('add_drop_fields').style.display = "none";
            document.getElementById('save_button_div').style.display = "none";
            
            document.getElementById('add_drop_success_message').style.display = "block";
            window.removeEventListener('beforeunload', this.handleLeavePage);
        } else {
            this.setState({
                class_selection_error_msg: 'There is some problem in saving your changes.'
            });
            
            document.getElementById('step_1_warning').style.display = "block";
        }
    }

    getUserData(){
        axios.get(this.user_info_url)
        .then((response) => {
            this.context.checkLoginOnSGL();
            if(response.data.user && response.data.user != null){
            this.setState({
                userData : response.data.user,
            });
            }else{
            }
        }, (error) => {
        });
    }

    getPendingClassesList(entry_data){
        return <td>
            {(entry_data.add_class_numb_name_list.length > 0 ) &&
            <ul>
                <li className='class_list_li'><b>Classes Added:</b></li>
                {entry_data.add_class_numb_name_list.map((item)=>
                <li className='class_list_li'>{item}</li>)}
            </ul>
            }
            {(entry_data.drop_class_numb_name_list.length > 0 ) &&
            <ul>
                <li className='class_list_li'><b>Classes Dropped:</b></li>
                {entry_data.drop_class_numb_name_list.map((item)=>
                <li className='class_list_li'>{item}</li>)}
            </ul>
            }
        </td>
    }
    render(){
        const loading = this.state.loading;
        if(loading) {
            return null;
        }
        if(this.state.switch_allowed != 1){
            return(
                <div>
                    <h2>Trainer Add/Drop</h2>
                    <p>{this.state.switch_company_name + ' does not support this feature.'}</p>
                </div>
            )
        }
        return(
            <div className="sgl-plugin addDropClassCss add-entry-page">
              
                <div>
                    <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
                    <div id="ringWrapper" className='ringWrapper'>
                    {(this.state.credit_hold && this.state.credit_hold_count > 0) ?
                    <div id='checkout_redirect'>
                        <div id="step_1_container" className='sgl-primary-header class-details primary-header class-details-header sgl-primary-header active_block' >
                            <p id="step_1_holding" className="sgl-no-text-shadow ring-name sgl-nm-ring-name ">Trainer Add/Drop</p>
                        </div>
                        <div id='credit_hold_warning'>
                            <p>Your account is currently on credit hold.  To continue please provide payment for your unpaid balances.</p>
                        </div>
                        <button className='sgl-button' >
                            <Link to='/checkout-entries' className="button-link">Pay Now</Link>
                        </button>
                              
                    </div>
                    :
                        <div className="div-responsive">

                        {/* add/drop class step 1 - Add/Drop classes */}
                            <div id="step_1_container" className='sgl-primary-header class-details primary-header class-details-header sgl-primary-header active_block'>
                                <p id="step_1_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name ">Trainer Add/Drop</p>
                            </div>

                            {(!this.state.show_data.show_closed && this.state.can_add_drop_class && this.state.trainer_entries_data.length > 0) ?
                                <div id='step_4' className='add_entry_class add-entry-div'> 
                                    <div id='add_drop_success_message' className='display_none'>
                                        <span>Your class add/drop request has been completed. The changes will be applied in the show office shortly and an email confirming this request has been sent to {this.state.userData.email_address}. A second email will be sent once the change is completed.</span>
                                    </div>
                                    <div id='add_drop_error_message' className='display_none'>
                                        <span>
                                            Your request for Entries Add/Drop could not be submitted because there was no valid add/drop in request.
                                        </span>
                                    </div>
                                    <ul id='add_drop_fields'>

                                        <div className="trainer-info-container">
                                            <table className="trainer-info-table">
                                                <tbody>
                                                    <tr>
                                                        <th><b>Trainer:</b></th>
                                                        <td>{this.state.trainer_entries_data[0]["trainer"]}</td>
                                                    </tr>
                                                    <tr colspan="2">
                                                        <th><b>Stable:</b></th>
                                                        <td>{this.state.trainer_entries_data[0]["stable"]}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <h3>Trainer Entries for {this.state.show_data.show_name}</h3>
                                        <table className="table table-striped-3 table-hover">
                            
                                            <tbody>
                                            <tr className="sgl-primary-header">
                                                <th className="center-align trainer-display_on_mobile display_on_tablet">Entry Details</th>
                                                <th className="center-align trainer_display_on_desktop">Entry</th>
                                                <th className="trainer_display_on_desktop">Horse</th>
                                                <th className="trainer_display_on_desktop">Rider</th>
                                                <th className="hide_on_mobile">Class Numbers</th>
                                                <th style={{width: "170px"}}>Classes</th>

                                            </tr>
                                            
                                                {this.state.trainer_entries_data.map((trainer_entry_data, index) => {
                                                return [
                                                    <tr className='sgl-anchor' key={trainer_entry_data.number}>
                                                        <td className="trainer-display_on_mobile display_on_tablet">
                                                        <div>{trainer_entry_data.number} - {trainer_entry_data.horse}</div>
                                                        <div>{trainer_entry_data.rider_name}</div>
                                                        <table className='add-drop-table trainer-display_on_mobile'>
                                                            <tr>
                                                            <td>
                                                                Adds
                                                            </td>
                                                            <td className="add-drop-input-container">
                                                                <input className='add-drop-input' 
                                                                    value = {trainer_entry_data.add_classes}
                                                                    onBlur={evt => this.checkClassAdds(evt, trainer_entry_data)}
                                                                    onChange={evt => this.updateAddClassNumbers(evt, trainer_entry_data)} 
                                                                >
                                                                </input>
                                                                {trainer_entry_data.success_add === true &&
                                                                    <img src={tick_icon} className="placing-icon add-entry-trash-icon tick_icon" />
                                                                }
                                                            </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                Drops
                                                                </td>
                                                                <td className="add-drop-input-container">
                                                                    <input className='add-drop-input' 
                                                                    value = {trainer_entry_data.drop_classes}
                                                                    onBlur={evt => this.checkClassDrops(evt, trainer_entry_data)}
                                                                    onChange={evt => this.updateDropClassNumbers(evt, trainer_entry_data)} 
                                                                    >
                                                                    </input>
                                                                    {trainer_entry_data.success_drop === true &&
                                                                    <img src={tick_icon} className="placing-icon add-entry-trash-icon tick_icon" />
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        </td>
                                                        <td className="trainer_display_on_desktop" nowrap="nowrap">{trainer_entry_data.number}</td>
                                                        <td className="trainer_display_on_desktop">{trainer_entry_data.horse}</td>
                                                        <td className="trainer_display_on_desktop">{trainer_entry_data.rider_name}</td>
                                                        
                                                        <td className="hide_on_mobile">
                                                            <table className='add-drop-table'>
                                                                <tr>
                                                                    <td>
                                                                        Adds
                                                                    </td>
                                                                    <td className="add-drop-input-container">
                                                                        <input className='add-drop-input' 
                                                                            value = {trainer_entry_data.add_classes}
                                                                            onBlur={evt => this.checkClassAdds(evt, trainer_entry_data)}
                                                                            onChange={evt => this.updateAddClassNumbers(evt, trainer_entry_data)} 
                                                                        >
                                                                        </input>
                                                                        {trainer_entry_data.success_add === true &&
                                                                            <img src={tick_icon} className="placing-icon add-entry-trash-icon tick_icon" />
                                                                        }
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        Drops
                                                                    </td>
                                                                    <td className="add-drop-input-container">
                                                                        <input className='add-drop-input' 
                                                                            value = {trainer_entry_data.drop_classes}
                                                                            onBlur={evt => this.checkClassDrops(evt, trainer_entry_data)}
                                                                            onChange={evt => this.updateDropClassNumbers(evt, trainer_entry_data)} 
                                                                        >
                                                                        </input>
                                                                        {trainer_entry_data.success_drop === true &&
                                                                            <img src={tick_icon} className="placing-icon add-entry-trash-icon tick_icon" />
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                        
                                                        <td>{trainer_entry_data.classes_list}</td>
                                                    </tr>,
                                                    <tr>
                                                        {trainer_entry_data.error_msg != '' &&

                                                            <td colspan="5">
                                                                <span className='required new-line'>{trainer_entry_data.error_msg}</span>
                                                            
                                                            </td>
                                                        }
                                                    </tr>
                                                ]
                                                })
                                                }
                                            </tbody>
                                        </table>

                                        <li className='entry_people_li'>
                                            <div id='step_1_warning' className='new-line required display_none' dangerouslySetInnerHTML={{ __html: this.state.class_selection_error_msg }}></div>
                                        </li>
                                        
                                    </ul>
                                    
                                    <div id='save_button_div' className='continue-button-div'>
                                    
                                        <button className='sgl-button' onClick={this.saveClassAddDrop()}>
                                            Save
                                        </button>
                                    </div>
                                </div>
                            :
                                <div id='show_close_warning' className='new-line required'>
                                    {this.state.show_data.show_closed ?
                                        <span>Show is closed. You cannot add/drop classes.</span>
                                    :
                                        <span>{!this.state.can_add_drop_class ? 'You do not have permission to add/drop classes.' : 'You have no entries as trainer in this show.' }</span>
                                    }
                                </div>
                            }
                            
                        {/* add/drp class - Pending requests */}

                            <div id="step_2_container" className='sgl-primary-header class-details, primary-header class-details-header add_entry_options'>
                                <p id="step_2_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Pending Requests</p>
                            </div>
                            <div id='step_2' className='add_entry_class add-entry-div'> 
                                
                                
                                <ul>
                                <li className='entry_people_li'>
                                    { (this.state.pending_requests_list.length > 0) &&
                                        <table className="table table-striped table-hover">
                                        <thead className="classes-header">
                                            <tr className="sgl-primary-header">
                                            <th>Entry Number</th>
                                            <th >Class List</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        { 
                                            this.state.pending_requests_list.map((data, index) => {
                                            return (
                                                <tr className="sgl-anchor" key={data.number}>
                                                <td>{data.number}</td>
                                                {this.getPendingClassesList(data)}
                                                </tr>
                                            )
                                            })
                                        }
                                        </tbody>
                                        </table>
                                    }

                                </li>
                                
                                </ul>
                                
                            </div>

                        </div>
                    }
                    </div>
                </div>
              
            <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
            </div>
        )
    }
}
AddDropTrainer.contextType = SglContext;
AddDropTrainer.navigate = useNavigate;

export default AddDropTrainer;